import React from "react";
import { Button, Dialog, DialogContent } from "@mui/material";
import "./bookingErrorPopup.scss";

interface BookingErrorPopupProps {
  isOpen: boolean;
  totalUnits?: number;
  sendedUnits?: number;
  missingUnits?: number;
}
const onHandleClick = () => {};

const BookingErrorPopup: React.FC<BookingErrorPopupProps> = ({
  isOpen,
  totalUnits,
  sendedUnits,
  missingUnits,
}) => {
  totalUnits = totalUnits || 17;
  sendedUnits = sendedUnits || 12;
  missingUnits = missingUnits || 5;
  return (
    <Dialog className="booking-error-dialog" open={isOpen}>
      <DialogContent id="booking-error-dialog-content">
        <h1 id="title-of-booking-error">
          {missingUnits} of {totalUnits} units cannot be sent!
        </h1>
        <p className="text-content-of-booking-error" id="sent-text">
          {sendedUnits} units were sent.
        </p>
        <p className="text-content-of-booking-error" id="missing-info-text">
          {missingUnits} units have missing information. You need to fill unit
          information to sent.
        </p>
        <Button
          onClick={onHandleClick}
          id="button-of-booking-error-ok"
          variant="text"
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default BookingErrorPopup;
